/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {v4 as uuidv4} from 'uuid';
import {isset} from "@/util/util";

/**
 *
 * @class TaskUpdate
 *
 * @brief base class for the updates we send from long-running tasks to the task
 * to the task monitor widget.  Initially its just file upload/download progress,
 * but maybe later it will be other long-running tasks as well.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2021
 *
 */
export class TaskUpdate {

  /** the id of the task, used to filter streams of task updates */
  public id:      string;

  /** the kind of update in this task's progress update stream */
  public type:    TaskUpdateType;

  /** updates should all provide a 0.0 - 100.0 completion progress */
  public progress: number         = 0.0;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id for the task involved (the context)
   * @param type     the kind of progress update
   * @param progress the 0-100% absolute progress for this task
   *
   */
  constructor(id: string, type: TaskUpdateType, progress: number = 0.0) {

    this.id       = id;
    this.type     = type;
    this.progress = progress;
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return '';
  }

  /** generate a good quality unique id */
  static generateId(): string {

    return uuidv4();
  }

  /** is this task complete? */
  isComplete(): boolean {

    return false;
  }

  /** helper to convert error results into simple strings to show the user */
  errorToString(error: any): string {

    if (typeof error == 'string') {

      return error;
    }

    if (isset(error.error)) {

      if (typeof error.error == 'string') {

        return error.error;
      }
    }

    if (isset(error.message)) {

      if (typeof error.message == 'string') {

        return error.message;
      }
    }

    if (isset(error.error.message)) {

      return error.error.message;
    }

    return error;
  }
}

/** the kinds of task progress updates */
export enum TaskUpdateType {
  Complete= 0,
  Fail=     1,
  Error=    2,
  Info=     3,
  Warning=  4,
  Debug=    5,
  Clear=    6,
  Progress= 7
}
